import QueryString from 'qs';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { goFunc, handlePostMessage } from '../js/postMessage';
import { getParsedLocalStorageItem } from '../js/script';

export default function CloseT() {
  const location = useLocation();

  useEffect(() => {
    const date = new Date();
    const app = getParsedLocalStorageItem('app');
    if (app) {
      goFunc({ date: date });
      // handlePostMessage({ actionType: 'goFunc', params: { data: date } });
      // onClose();
      handlePostMessage({ actionType: 'onClose' });
    }
    const query = QueryString.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (query.resultCode === '7028') {
      alert(query.resultMsg);
    }
    const sendMessage = () => {
      const currentUrl = new Date();
      if (window.opener) {
        const message = {
          type: 'date',
          date: currentUrl,
        };
        window.opener.postMessage(message);
      }
    };

    // URL이 변경될 때마다 전송
    sendMessage();
    window.close();
  }, [location]);
  return <p>팝업테스트</p>;
}
